import { useApi } from '../useApi';
import {  prepareAuthHeaders } from '../requestsHelper';
import { baseUrl, ServiceName } from '../urlHelper';

import User from '../../security/type/User';
import { CONSTANTS_PATH } from '../constant';


export const useUpdateUserAPI = () => {
    const { apiCall } = useApi();

    const updateUser = async (userId: number, userData: User): Promise<User> => {
        const url: string = `${baseUrl(ServiceName.USERS)}${CONSTANTS_PATH.USER_SERVICE}/${userId}`;

        return await apiCall<User>(
            url,
            {
                method: 'PUT',
                data: userData,
                headers: {
                    ...prepareAuthHeaders(),
                },
            },
            'User updated successfully!'
        );
    };

    return { updateUser };
};
